import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=3e1e9e38"
import script from "./Reorder.vue?vue&type=script&lang=js"
export * from "./Reorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports